<template>
  <div class="container">
    <div class="companyBox">
      <div class="companyName">{{ info.Headline }}</div>
      <div class="introduceBox">
        <div class="introduceItem">
          <span class="title">联系人</span>
          <span style="color: #999999">：</span>
          <span class="content">{{ info.TrueName }}</span>
        </div>
        <div class="introduceItem">
          <span class="title">固定电话</span>
          <span style="color: #999999">：</span>
          <span class="content">{{ info.Tel }}</span>
        </div>
        <div class="introduceItem">
          <span class="title">传真</span>
          <span style="color: #999999">：</span>
          <span class="content">{{ info.Fax }}</span>
        </div>
        <div class="introduceItem">
          <span class="title">地址</span>
          <span style="color: #999999">：</span>
          <span class="content">{{ info.CompanyAddress }}</span>
        </div>
        <div class="introduceItem">
          <span class="title">公司主页</span>
          <span style="color: #999999">：</span>
          <span class="content" style="color: #2268e8">{{ info.Website }}</span>
        </div>
        <div class="actionBox">
          <div class="actionItem">
            <img
              class="iconImg"
              style="margin-right: 20rpx"
              src="../../../static/images/productDetail/call.png"
            />
            <div>
              <a style="color: #666" :href="'tel:' + info.Tel">打电话</a>
            </div>
          </div>
          <div class="actionItem">
            <img
              class="iconImg"
              style="margin-right: 14rpx"
              src="../../../static/images/productDetail/card.png"
            />

            <div>
              <a style="color: #666" :href="'tel:' + info.Tel">存名片</a>
            </div>
          </div>
          <div class="actionItem" @click="locationHandle">
            <img
              class="iconImg"
              style="margin-right: 8rpx"
              src="../../../static/images/productDetail/position.png"
            />
            <div>点击导航</div>
          </div>
        </div>
      </div>
    </div>
    <div
      id="container"
      style="width: 100%; height: 300px; margin-bottom: 50px"
    ></div>
    <div class="footerSBox">
      <div class="footItem" @click="tabHandle(1)">
        <img
          src="../../../static/images/tabBar/menu1_on.png"
          class="homeIcon"
          v-if="active == 1"
          alt=""
        />
        <img
          src="../../../static/images/tabBar/menu1_off.png"
          class="homeIcon"
          v-else
          alt=""
        />
        <div class="footText">首页</div>
      </div>
      <div class="footItem" @click="tabHandle(2)">
        <img
          src="../../../static/images/tabBar/menu2_on.png"
          class="homeIcon"
          v-if="active == 2"
          alt=""
        />
        <img
          src="../../../static/images/tabBar/menu2_off.png"
          class="homeIcon"
          v-else
          alt=""
        />
        <div class="footText">产品</div>
      </div>
      <div class="footItem" @click="tabHandle(3)">
        <img
          src="../../../static/images/tabBar/menu3_on.png"
          class="homeIcon"
          v-if="active == 3"
          alt=""
        />
        <img
          src="../../../static/images/tabBar/menu3_off.png"
          class="homeIcon"
          v-else
          alt=""
        />
        <div class="footText">公司介绍</div>
      </div>
      <div class="footItem" @click="tabHandle(4)">
        <img
          src="../../../static/images/tabBar/menu4_on.png"
          class="homeIcon"
          v-if="active == 4"
          alt=""
        />
        <img
          src="../../../static/images/tabBar/menu4_off.png"
          class="homeIcon"
          v-else
          alt=""
        />
        <div class="footText">联系</div>
      </div>
    </div>
  </div>
</template>
<script>
import { companyInfo } from "@/api/store";
import { getShareData } from "@/utils/share";
export default {
  name: "contact",
  data() {
    return {
      info: "",
      lat: 0,
      lng: 0,
      active: 4,
    };
  },
  methods: {
    //tab切换
    tabHandle(type) {
      if (type == 1) {
        this.active = 1;
        this.$router.push({
          path: "/storeShow",
          query: { mid: this.$route.query.mid },
        });
      } else if (type == 2) {
        this.active = 2;
        this.$router.push({
          path: "/product",
          query: { mid: this.$route.query.mid },
        });
      } else if (type == 3) {
        this.active = 3;
        this.$router.push({
          path: "/companyIntro",
          query: { mid: this.$route.query.mid },
        });
      } else if (type == 4) {
        this.active = 4;
        this.$router.push({
          path: "/contact",
          query: { mid: this.$route.query.mid },
        });
      } else {
      }
    },

    //获取公司介绍
    getCompanyInfo() {
      var that = this;
      var data = { MemberId: this.$route.query.mid, BusinessMemberId: 0 };
      companyInfo(data).then((res) => {
        that.info = res.Data;
        that.lat = res.Data.CompanyMap.point_x;
        that.lng = res.Data.CompanyMap.point_y;
        that.address = res.Data.CompanyAddress;
        that.init(that.lng, that.lat);
        getShareData(
          window.location.href,
          res.Data.Headline,
          that.Common.ToText(res.Data.Introduction).substr(0, 50),
          res.Data.Photo
        );
      });
    },

    init: function (lng, lat) {
      var myLatlng = new qq.maps.LatLng(lng, lat);
      var myOptions = {
        zoom: 12,
        center: myLatlng,
        mapTypeId: qq.maps.MapTypeId.ROADMAP,
      };
      var map = new qq.maps.Map(
        document.getElementById("container"),
        myOptions
      );
      var marker = new qq.maps.Marker({
        position: myLatlng,
        map: map,
      });
    },

    //点击跳转腾讯地图
    locationHandle() {
      var that = this;
      console.log(that.lng, that.lat);
      window.location.href =
        "https://apis.map.qq.com/tools/routeplan/eword=" +
        that.address +
        "&epointx=" +
        that.lng +
        "&epointy=" +
        that.lat +
        "?referer=myapp&key=47EBZ-MF42X-TEC42-Z563P-BLX67-C7FB5";
    },
  },
  mounted() {
    this.getCompanyInfo();
  },
};
</script>
<style  lang="less" scoped>
.companyBox {
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding: 0 13px;
  padding-bottom: 43px;
  .companyName {
    height: 63px;
    display: flex;
    flex-direction: row;
    align-items: center;
    border-bottom: 1px solid #dddddd;
    font-size: 17px;
    font-weight: 800;
  }
  .introduceBox {
    display: flex;
    flex-direction: column;
    font-size: 14px;
    padding-top: 21px;
    .introduceItem {
      margin-bottom: 5px;
      .title {
        color: #999999;
        min-width: 50px;
        display: inline-block;
        text-align: justify;
        text-align-last: justify;
      }
      .content {
        color: #333;
      }
    }
    .actionBox {
      margin-top: 35px;
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      .actionItem {
        width: 100px;
        height: 40px;
        box-sizing: border-box;
        border: 1px solid #ccc;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        color: #666;
        border-radius: 5px;
        .iconImg {
          width: 25px;
          height: 25px;
        }
      }
    }
  }
}
</style>

